module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_10_50.0a07a614.png";